module.exports = __webpack_public_path__ + "ab955a31cdf946af6ea8c713ddf1b40e.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/team_jeremias_mobile_teaser.jpg
// module id = 670
// module chunks = 0